import React from 'react';
import PropTypes from 'prop-types';
import { Brush, PictureInPicture } from 'tabler-icons-react';
import AppStack from '../../common/AppStack';
import AppCard from '../../common/AppCard';
import AppText from '../../common/AppText';
import { useModalState } from '../../../helpers/hooks';
import * as classes from '../../../styles/nestedStyles.module.css';
import SelectMediaModal from '../media/SelectMediaModal';
import { triggerNotification } from '../../../helpers/notification';

const TOOL_BAR_OPTIONS = [
  {
    value: 'image',
    label: 'Add image',
    icon: <PictureInPicture size={18} />
  },
  {
    value: 'personalize',
    label: 'Personalize',
    isMenu: true,
    icon: <Brush size={18} />
  }
  // {
  //   id: 'graphics',
  //   label: 'Graphics',
  //   icon: <Flower size={18} />,
  //   action: () => {
  //   }
  // }
];

const PrintDesignEditorToolbar = ({
  canvasController,
  fkEcomVendor,
  fkEcomStore,
  setPrintTemplateState,
  toolbarMenuState,
  setToolbarMenuState,
  loading
}) => {
  const { state: modalState, onOpenModal, onCloseModal } = useModalState();

  const handleButtonAction = (action, isMenu) => {
    if (isMenu) {
      setToolbarMenuState({
        action,
        isOpen: true
      });
    }
    else {
      if (toolbarMenuState.isOpen) {
        setToolbarMenuState({
          ...toolbarMenuState,
          isOpen: false
        });
      }

      onOpenModal(action);
    }
  };

  return (
    <AppStack
      style={{ flex: 1, maxWidth: 100, height: '100%', position: 'relative' }}
    >
      <AppCard
        radius={0}
        style={{
          padding: 0,
          width: '100%',
          height: '100%',
          borderRight: 'solid 1px lightgrey'
        }}
      >
        <AppStack style={{ padding: 8, gap: 16 }}>
          {TOOL_BAR_OPTIONS.map((option) => (
            <AppCard
              key={option.value}
              className={!loading ? classes['hover-action-card'] : null}
              onClick={() => {
                if (!loading) {
                  handleButtonAction(option.value, option.isMenu);
                }
              }}
              radius={8}
              shadow="xs"
              style={{
                padding: '8px 4px',
                width: '100%',
                height: '100%',
                cursor: loading ? 'not-allowed' : 'pointer',
                backgroundColor: loading
                  ? '#D1D1D1'
                  : toolbarMenuState.isOpen &&
                    toolbarMenuState.action === option.value
                  ? '#E0E0E0'
                  : '#FFF'
              }}
              withBorder
            >
              <AppStack style={{ gap: 0, alignItems: 'center' }}>
                {option.icon}
                <AppText
                  style={{ fontSize: 12, fontWeight: 500, textAlign: 'center' }}
                >
                  {option.label}
                </AppText>
              </AppStack>
            </AppCard>
          ))}
        </AppStack>
      </AppCard>

      <SelectMediaModal
        fkEcomStore={fkEcomStore}
        fkEcomVendor={fkEcomVendor}
        isOpen={modalState.isOpen && modalState.action === 'image'}
        maxSelectCount={1}
        newMedia={[]}
        onClose={onCloseModal}
        onConfirm={async (images) => {
          onCloseModal();
          if (images && images[0]) {
            setPrintTemplateState((prevState) => ({
              ...prevState,
              loadingImageUrls: [...prevState.loadingImageUrls, images[0].src]
            }));

            canvasController
              .addImageByUrl(images[0].src)
              .then((d) => {
                setPrintTemplateState((prevState) => ({
                  ...prevState,
                  loadingImageUrls: prevState.loadingImageUrls.filter(
                    (url) => url !== images[0].src
                  ),
                  pkEcomVendorMedia: images[0].pkEcomVendorMedia,
                  pkEcomStoreMedia: images[0].pkEcomStoreMedia,
                  preview: images[0].src
                }));
              })
              .catch((e) => {
                triggerNotification(
                  "Image couldn't be loaded. Please try again or upload a new one."
                );
                setPrintTemplateState((prevState) => ({
                  ...prevState,
                  loadingImageUrls: prevState.loadingImageUrls.filter(
                    (url) => url !== images[0].src
                  )
                }));
              });
          }
        }}
        selectedMedia={[]}
        uploadOnDrop
      />
    </AppStack>
  );
};

PrintDesignEditorToolbar.propTypes = {
  canvasController: PropTypes.object.isRequired,
  setPrintTemplateState: PropTypes.func.isRequired,
  setToolbarMenuState: PropTypes.func.isRequired,
  toolbarMenuState: PropTypes.object.isRequired,
  fkEcomStore: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  fkEcomVendor: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  loading: PropTypes.bool
};

export default PrintDesignEditorToolbar;
